import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaoconsultaimpedimentos(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaoconsultaimpedimentos/FIND_CONSULTAIMPEDIMENTOS':
      case '@operacaoconsultaimpedimentos/UPDATE_CONSULTAIMPEDIMENTOS':
      case '@operacaoconsultaimpedimentos/DELETE_CONSULTAIMPEDIMENTOS':
      case '@operacaoconsultaimpedimentos/STORE_CONSULTAIMPEDIMENTOS':
      case '@operacaoconsultaimpedimentos/CONSULTAIMPEDIMENTOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaoconsultaimpedimentos/SUCCESS_REMOVE':
      case '@operacaoconsultaimpedimentos/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaoconsultaimpedimentos/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaoconsultaimpedimentos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaoconsultaimpedimentos/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaoconsultaimpedimentos;
        break;
      }

      case '@operacaoconsultaimpedimentos/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
